import React from 'react'
import { colors, borderRadius } from '../../styles/tokens'

/**
 * Área de input do chat com anexo de arquivos
 * 
 * Single Responsibility: Input de texto e botão de envio
 */
export default function ChatInput({
  prompt,
  setPrompt,
  files,
  loading,
  fileInputRef,
  onSubmit,
  onOpenFilePicker
}) {
  const canSubmit = !loading && prompt.trim() && files.length > 0

  return (
    <div style={{
      padding: '1rem 1.5rem',
      display: 'flex',
      gap: '0.75rem',
      alignItems: 'flex-end'
    }}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={(e) => {}}
        multiple
        accept=".pdf,.png,.jpg,.jpeg"
        style={{ display: 'none' }}
      />

      <button
        onClick={onOpenFilePicker}
        disabled={loading}
        style={{
          padding: '0.75rem',
          backgroundColor: colors.background,
          border: `1px solid ${colors.border}`,
          borderRadius: borderRadius.md,
          cursor: 'pointer',
          fontSize: '1.25rem'
        }}
        title="Anexar arquivos"
      >
        📎
      </button>

      <textarea
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder="Ex: pacote bariloche 2 adultos com voo hotel e passeios"
        disabled={loading}
        rows={2}
        style={{
          flex: 1,
          padding: '0.75rem 1rem',
          borderRadius: borderRadius.md,
          border: `1px solid ${colors.border}`,
          backgroundColor: colors.background,
          color: colors.text.primary,
          fontSize: '1rem',
          resize: 'none',
          fontFamily: 'inherit'
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            if (canSubmit) onSubmit()
          }
        }}
      />

      <button
        onClick={onSubmit}
        disabled={!canSubmit}
        style={{
          padding: '0.75rem 1.5rem',
          backgroundColor: colors.primary,
          color: 'white',
          border: 'none',
          borderRadius: borderRadius.md,
          fontWeight: 500,
          cursor: canSubmit ? 'pointer' : 'not-allowed',
          opacity: canSubmit ? 1 : 0.5,
          whiteSpace: 'nowrap'
        }}
      >
        {loading ? '⏳' : 'Enviar'}
      </button>
    </div>
  )
}
